import { useState } from "react";
import axios from "axios";
import "@/App.css";
import { INITIAL, PREFILL } from "./content";
import { Header, Progress, Footer, Thanks } from "./components/fiche/Chrome";
import { StepOne } from "./components/fiche/StepOne";
import { StepTwo } from "./components/fiche/StepTwo";
import Admin from "./pages/Admin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const prefilled = () => {
  const p = new URLSearchParams(window.location.search);
  const d = { ...INITIAL };
  PREFILL.forEach((k) => p.get(k) && (d[k] = p.get(k)));
  return d;
};

const checkStepOne = (d) => {
  const e = {};
  if (!d.nom.trim()) e.nom = "Indiquez votre prénom et nom pour continuer";
  if (!d.fonction.trim()) e.fonction = "Indiquez votre fonction pour continuer";
  if (!d.organisation.trim()) e.organisation = "Indiquez votre organisation pour continuer";
  if (!d.courriel.trim()) e.courriel = "Indiquez votre courriel pour continuer";
  else if (!EMAIL_RE.test(d.courriel.trim())) e.courriel = "Indiquez un courriel au format nom@domaine.com";
  return e;
};

const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

function Fiche() {
  const [data, setData] = useState(prefilled);
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [notice, setNotice] = useState("");

  const set = (k, v) => {
    setData((d) => ({ ...d, [k]: v, ...(k === "priorites" && !v.includes("Autre") ? { priorite_autre: "" } : {}) }));
    if (errors[k]) setErrors((e) => ({ ...e, [k]: undefined }));
  };

  const next = () => {
    const e = checkStepOne(data);
    setErrors(e);
    if (Object.keys(e).length) {
      document.getElementById(Object.keys(e)[0])?.focus();
      return;
    }
    setStep(2);
    scrollTop();
  };

  const submit = async () => {
    if (!data.consentement) {
      setErrors({ consentement: "Cochez cette case pour envoyer votre fiche" });
      return;
    }
    setSending(true);
    setNotice("");
    try {
      await axios.post(`${API}/fiche`, { ...data, courriel: data.courriel.trim() });
      setDone(true);
      scrollTop();
    } catch {
      setNotice("L'envoi demande un nouvel essai. Vos réponses sont conservées, cliquez de nouveau sur « Envoyer ma fiche ».");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="ob-page">
      <main className="ob-wrap">
        <Header />
        {done ? (
          <Thanks />
        ) : (
          <form onSubmit={(e) => e.preventDefault()} noValidate data-testid="fiche-form">
            <Progress step={step} />
            <input
              type="text" name="site_web" tabIndex={-1} autoComplete="off" aria-hidden="true"
              className="ob-honey" value={data.site_web} onChange={(e) => set("site_web", e.target.value)}
            />
            <div key={step} className="ob-step">
              {step === 1 ? <StepOne data={data} set={set} errors={errors} /> : <StepTwo data={data} set={set} errors={errors} />}
            </div>
            <div className="ob-actions">
              {step === 1 ? (
                <button type="button" className="ob-btn" onClick={next} data-testid="fiche-continue-button">Continuer</button>
              ) : (
                <>
                  <button type="button" className="ob-btn" onClick={submit} disabled={sending} data-testid="fiche-submit-button">
                    {sending ? "Envoi en cours" : "Envoyer ma fiche"}
                  </button>
                  {notice && <p className="ob-hint" data-testid="fiche-submit-notice">{notice}</p>}
                  <button type="button" className="ob-back" onClick={() => { setStep(1); scrollTop(); }} data-testid="fiche-back-button">
                    Revenir à l'étape 1
                  </button>
                </>
              )}
            </div>
          </form>
        )}
        <Footer />
      </main>
    </div>
  );
}

export default function App() {
  return window.location.pathname.startsWith("/admin") ? <Admin /> : <Fiche />;
}
